export default "__VITE_ASSET__R3AcXXZa__"